import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { Mail, Phone, Facebook, Instagram } from 'lucide-react';

export default function Footer() {
    const navigate = useNavigate();
    const handleNavigation = (sectionId) => {
        navigate("/", { replace: true });
        setTimeout(() => {
            if (sectionId) {
                const section = document.getElementById(sectionId);
                section.scrollIntoView({ behavior: 'smooth' });
            } else {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        }, 100);
    };

    return (
        <footer className="footer py-5 mt-5">
            <Container>
                <Row className="gy-4">
                    <Col lg={4} md={6}>
                        <div className="mb-4">
                            <Link to="/" className="d-flex align-items-center text-white text-decoration-none mb-3">
                                <img
                                    src="favicon-32x32.png"
                                    className="me-2"
                                    alt="VisionThink Tech Logo"
                                />
                                <span className="fs-4 fw-bold" style={{ background: 'linear-gradient(135deg, #6cc3f4 0%, #80abe9 50%, #b26dcd 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text', color: 'white', display: 'inline-block' }}>VisionThink Tech</span>
                            </Link>
                            <p className="text-light">
                                Empowering healthcare professionals with innovative digital solutions to streamline clinic operations and enhance patient care.
                            </p>
                            <div className="d-flex gap-3 mt-4">
                                {/* <a
                                    aria-label="Facebook"
                                    href="https://facebook.com/manomay.homeo/"
                                    target="_blank"
                                    className="text-white"
                                    rel="noopener noreferrer"
                                >
                                    <Facebook size={20} />
                                </a> */}
                                <a
                                    aria-label="Instagram"
                                    href="https://instagram.com/visionthink_tech/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-white"
                                >
                                    <Instagram size={20} />
                                </a>
                            </div>
                        </div>
                    </Col>
                    <Col lg={4} md={6}>
                        <h5 className="text-white mb-4">Quick Links</h5>
                        <ul className="list-unstyled">
                            <li className="mb-2"><Link as={Button} onClick={() => handleNavigation()} className="text-light text-decoration-none">Home</Link></li>
                            <li className='mb-2'><Link as={Button} onClick={() => handleNavigation("features")} className='text-light text-decoration-none'>Features</Link></li>
                            <li className='mb-2'><Link as={Button} onClick={() => handleNavigation("benefits")} className='text-light text-decoration-none'>Benefits</Link></li>
                        </ul>
                    </Col>
                    <Col lg={4} md={6}>
                        <h5 className="text-white mb-4">Contact Us</h5>
                        <div className="mb-3 d-flex align-items-center">
                            <Phone size={20} className="text-light me-3 flex-shrink-0" />
                            <p className="text-light mb-0">+91-9421409687</p>
                        </div>
                        <div className="mb-3 d-flex align-items-center">
                            <Mail size={20} className="text-light me-3 flex-shrink-0" />
                            <a href='mailto:info@mediconnect.com' className="text-light mb-0">connect@visionthinktech.com</a>
                        </div>
                    </Col>
                </Row>
                <hr className="my-4 border-light opacity-10" />
                <div className="text-center text-light">
                    <p className="mb-0">&copy; {new Date().getFullYear()} VisionThink Tech. All rights reserved.</p>
                </div>
            </Container>
        </footer>
    );
}
